import {
  Apple,
  Bed,
  Bike,
  BookOpen,
  Brain,
  Check,
  CigaretteOff,
  Code,
  Coffee,
  Droplet,
  Dumbbell,
  Footprints,
  Heart,
  Languages,
  Leaf,
  Moon,
  Music,
  PenLine,
  Pill,
  Smartphone,
  Sparkles,
  Sun,
  Target,
  Utensils,
  Wallet,
  WineOff,
  type LucideIcon,
} from 'lucide-react';

const MAP: Record<string, LucideIcon> = {
  check: Check,
  book: BookOpen,
  dumbbell: Dumbbell,
  droplet: Droplet,
  moon: Moon,
  footprints: Footprints,
  brain: Brain,
  apple: Apple,
  pill: Pill,
  music: Music,
  pen: PenLine,
  code: Code,
  leaf: Leaf,
  bike: Bike,
  coffee: Coffee,
  'cigarette-off': CigaretteOff,
  'wine-off': WineOff,
  smartphone: Smartphone,
  heart: Heart,
  sun: Sun,
  bed: Bed,
  target: Target,
  languages: Languages,
  wallet: Wallet,
  sparkles: Sparkles,
  utensils: Utensils,
};

export function HabitIcon({ name, size = 22 }: { name: string; size?: number }) {
  const Icon = MAP[name] ?? Sparkles;
  return <Icon size={size} strokeWidth={2} aria-hidden="true" />;
}
